document.addEventListener("DOMContentLoaded", () => {
  const excludedTypes = [
    "bears",
    "balloons",
    "add on",
    "budget sets",
    "christmas gift sets",
    "flower school",
    "flower school online",
    "funeral",
    "gift card custom",
    "gifting chocolates",
    "giftsets",
    "group on",
    "jewellery",
    "roses gift box",
    "test-product",
    "vases"
  ]
  let addToCartButton = null
  document.addEventListener("click", event => {
    const target = event.target
    if (!(target instanceof Element)) return
    addToCartButton = target.closest(
      "button.product-form__submit.button.button--full-width.button--secondary"
    )
    if (!addToCartButton || !addToCartButton.closest("product-form")) return
  })
  const originalFetch = window.fetch
  window.fetch = async function (...args) {
    const response = await originalFetch.apply(this, args)
    const url = args[0] || ""
    if (typeof url === "string" && (url.includes("/cart/add") || url.includes("/cart/add.js"))) {
      const clone = response.clone()
      try {
        const data = await clone.json()
        const items = data.items || [data]
        let isMainProduct = false
        let targetProductId = null
        let targetVariantId = null
        let isSubscription = false
        let isExcludedType = false

        for (const item of items) {
          const props = item.properties || {}
          const isAddon = props["Addon Of"] || props["uniqueId"] || props["addonId"]
          if (!isAddon && item.product_id) {
            isMainProduct = true
            targetProductId = item.product_id
            targetVariantId = item.variant_id
            if (item.selling_plan_allocation || item.selling_plan) {
              isSubscription = true
            }
            if (item.product_type && excludedTypes.includes(item.product_type.toLowerCase())) {
              isExcludedType = true
            }
            break
          }
        }

        const currentTemplate = window.templateSuffix || ""
        const shouldSkip = currentTemplate === "funeral" || isSubscription || isExcludedType

        if (isMainProduct && !shouldSkip) {
          addToCartButton?.querySelector(".loading__spinner")?.classList.add("hidden")
          addToCartButton?.removeAttribute("aria-disabled")
          const drawer = document.querySelector("cart-drawer")
          if (drawer) drawer.style.visibility = "hidden"
          const uid = Date.now().toString() + Math.floor(Math.random() * 10000).toString()
          window.location.href = `/pages/product-addons?for=${targetProductId}&variant=${targetVariantId}&uid=${uid}`
          return new Promise(() => {})
        }
      } catch (e) {}
    }
    return response
  }
})